import moment from 'moment';
import intl from 'react-intl-universal';
import { DATE_TIME_FORMAT } from '@/config';
import { parseYuan2Currency } from '@/utils/number';
import { getTimeByUtcOffset } from '@/utils/intl';

/**
 *
 * @param type 标签类型 div
 * @param style
 * @param children 标签内容
 * @returns
 */
const createElementByName = ({
  type = 'div',
  style,
  children,
}: {
  type?: string;
  style?: string;
  children?: any;
}) => {
  const div = document.createElement(type);
  if (style) {
    div.setAttribute('style', style);
  }
  if (children) {
    div.innerHTML = children;
  }
  return div;
};

const getDescItemHtml = (label, enLabel, value, align?: string) => {
  const container = createElementByName({});
  const div = createElementByName({ style: 'display: flex;' });
  const labelDiv = createElementByName({
    style: `font-weight: bold; margin-right: 16px; ${
      align === 'alignRight' ? 'min-width: 200px;' : ''
    } ${align === 'alignLeft' ? 'min-width: 140px' : ''}`,
    children: label,
  });
  const span = createElementByName({
    type: 'span',
    style: `margin-left: 8px;`,
    children: enLabel,
  });
  labelDiv.appendChild(span);
  const valueDiv = createElementByName({
    style: `${align === 'alignRight' ? 'min-width: 100px; text-align: right;' : ''}`,
    children: value,
  });
  div.appendChild(labelDiv);
  div.appendChild(valueDiv);
  container.appendChild(div);
  return container?.innerHTML;
};

// 打印样式
export const getPrintCss = () => {
  const cssStyleSheetStr = `
  <style rel="stylesheet">
    .container {
      font-size: 12px;
    }

    .description {
      display: flex;
    }
    .description .label {
      font-weight: bold;
      margin-right: 16px;
    }
    .description .enLable {
      margin-left: 8px;
    }

    .address {
      display: flex;
      font-weight: bold;
    }
    .address .logo {
      width: 34px;
      height: 20px;
    }
    .address .logo + div {
      margin: 0 8px;
    }

    .printTitle {
      margin: 16px auto;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
    }

    .printInfo {
      display: flex;
      justify-content: space-between;
      padding: 16px 0;
      border-bottom: 2px dashed #000040;
    }

    .guestInfo {
      // display: flex;
      // flex-wrap: wrap;
      // padding: 16px 0 0;
      padding: 16px 0;
      border-bottom: 2px dashed #000040;
    }
    // .guestInfo > div {
    //   margin-right: 32px;
    //   margin-bottom: 16px;
    // }

    .consume, .pay {
      padding: 16px 0;
      border-bottom: 2px dashed #000040;
    }

    .consume > div:first-of-type {
      margin-bottom: 16px;
      font-weight: bold;
    }
    .consume > div:first-of-type span {
      margin-left: 8px;
    }


    .pay > div:first-of-type {
      margin-bottom: 16px;
      font-weight: bold;
    }
    .pay > div:first-of-type span {
      margin-left: 8px;
    }

    table {
      width: 100%;
      font-size: 12px;
    }

    table thead {
      font-weight: bold;
    }

    table thead span {
      margin-left: 8px;
    }

    table tbody th, table tbody td {
      padding: 4px 0;
      font-weight: normal;
      border-collapse: collapse;
    }

    .consumeTotal, .payTotal {
      margin-top: 32px;
    }

    .consumeTotal > div, .payTotal > div {
      margin-bottom: 16px;
    }

    .hotel {
      display: flex;
      justify-content: space-between;
      padding: 16px 0;
    }

    .hotel .left  > div {
      margin-bottom: 16px;
    }
  </style>
  `;
  return cssStyleSheetStr;
};

// 动态标签和数据
export const getPrintHtml = (data) => {
  const { orderInfoResponse, consumeBills, paymentBills, accountTotal, hotelBasicInfoResp } =
    data || {};
  const container = `
    <div class="container">
      <div class="address">
        <div>${orderInfoResponse?.storeName}</div>
      </div>
      <div class="printTitle">${intl.get('cpm_bill_print_guest_detail_bill_form')}</div>
      <div class="printInfo">
        ${getDescItemHtml(
          intl.get('cpm_bill_print_time'),
          'Print',
          orderInfoResponse?.printTime
            ? getTimeByUtcOffset(orderInfoResponse?.printTime, DATE_TIME_FORMAT)
            : '',
        )}
        ${getDescItemHtml(
          intl.get('bill_invoice_modal_order_no'),
          'Order ID',
          orderInfoResponse?.resvNo,
        )}
      </div>
      <div class="guestInfo">
        <table>
          <tbody>
            <tr>
              <td>
                ${getDescItemHtml(
                  intl.get('help_store_address_table_column_name'),
                  'Name',
                  orderInfoResponse?.masterName,
                  'alignLeft',
                )}
              </td>
              <td>
                ${getDescItemHtml(
                  intl.get('app_reservation_cert_number'),
                  'Card No',
                  orderInfoResponse?.masterCertNo,
                  'alignLeft',
                )}
              </td>
            </tr>
            <tr>
              <td>
                ${getDescItemHtml(
                  intl.get('app_reservation_member_level'),
                  'Customer',
                  orderInfoResponse?.memberLevelName,
                  'alignLeft',
                )}
              </td>
              <td>
                ${getDescItemHtml(
                  intl.get('app_reservation_remain_balance'),
                  'Balance',
                  parseYuan2Currency(orderInfoResponse?.balance),
                  'alignLeft',
                )}
              </td>
            </tr>
            <tr>
              <td>
                ${getDescItemHtml(
                  intl.get('cpm_bill_print_arrival_time'),
                  'Arrival',
                  orderInfoResponse?.expectedArrivalTime
                    ? getTimeByUtcOffset(orderInfoResponse?.expectedArrivalTime, DATE_TIME_FORMAT)
                    : '',
                  'alignLeft',
                )}
              </td>
              <td>
                ${getDescItemHtml(
                  intl.get('channel_leave_time'),
                  'Departure',
                  orderInfoResponse?.expectedDepartureTime
                    ? getTimeByUtcOffset(orderInfoResponse?.expectedDepartureTime, DATE_TIME_FORMAT)
                    : '',
                  'alignLeft',
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="consume">
        <div>
          ${intl.get('bill_consume_detail')}<span>Consumption details</span>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width:20%">
                ${intl.get('bill_invoice_modal_time')}<span>Date</span>
              </th>
              <th style="width:15%;">
                ${intl.get('bill_room_no')}<span>Room No</span>
              </th>
              <th style="width:12%;">
                ${intl.get('handover_table_column_project')}<span>Type</span>
              </th>
              <th>
                ${intl.get('bill_refound_res_detail')}<span>Detail</span>
              </th>
              <th style="width:15%; text-align:right;">
                ${intl.get('bill_credit_amount')}<span>Amount</span>
              </th>
              <th style="width:18%; text-align:right;">
                ${intl.get('channel_preferential')}<span>Preferential</span>
              </th>
            </tr>
          </thead>
          <tbody>
          ${consumeBills
            ?.map(
              (item) => `
              <tr>
                <th>${
                  item.createTime ? getTimeByUtcOffset(item.createTime, DATE_TIME_FORMAT) : ''
                }</th>
                <th>${item.roomNo}</th>
                <th>${item.businessExplain}</th>
                <th>${item.detail}</th>
                <th style="text-align:right;">${parseYuan2Currency(item.amount)}</th>
                <th style="text-align:right;">${parseYuan2Currency(item.discountAmount)}</th>
              </tr>
            `,
            )
            .join('')}
          </tbody>
        </table>
        <div class="consumeTotal">
        ${getDescItemHtml(
          intl.get('cpm_bill_print_total_consumption'),
          'Total consumption',
          parseYuan2Currency(accountTotal?.consumeTotal),
          'alignRight',
        )}
        ${getDescItemHtml(
          intl.get('cpm_bill_print_total_preferential'),
          'Total preferential',
          parseYuan2Currency(accountTotal?.discountToTal),
          'alignRight',
        )}
        ${getDescItemHtml(
          intl.get('cpm_bill_print_actual_consumption'),
          'Actual consumption',
          parseYuan2Currency(accountTotal?.consumeAfterDiscountTotal),
          'alignRight',
        )}
        </div>
      </div>
      <div class="pay">
        <div>
          ${intl.get('cpm_bill_print_pay_detail')}<span>Payment details</span>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width:20%;">
                ${intl.get('bill_invoice_modal_time')}<span>Date</span>
              </th>
              <th style="width:15%;">
                ${intl.get('bill_room_no')}<span>Room No</span>
              </th>
              <th style="width:12%;">
                ${intl.get('handover_table_column_project')}<span>Type</span>
              </th>
              <th>
                ${intl.get('bill_refound_res_detail')}<span>Detail</span>
              </th>
              <th style="width:15%; text-align:right;">
                ${intl.get('bill_credit_amount')}<span>Amount</span>
              </th>
              <th style="width:18%; text-align:right;">
                ${intl.get('bill_config_refound')}<span>Refund</span>
              </th>
            </tr>
          </thead>
          <tbody>
          ${paymentBills
            ?.map(
              (item) => `
              <tr>
                <th>${
                  item.createTime ? getTimeByUtcOffset(item.createTime, DATE_TIME_FORMAT) : ''
                }</th>
                <th>${item.roomNo}</th>
                <th>${item.businessExplain}</th>
                <th>${item.detail}</th>
                <th style="text-align:right;">${parseYuan2Currency(item.amount)}</th>
                <th style="text-align:right;">${parseYuan2Currency(item.refundAmount)}</th>
              </tr>
            `,
            )
            .join('')}
          </tbody>
        </table>
        <div class="payTotal">
        ${getDescItemHtml(
          intl.get('bill_pay_total'),
          'Total payment',
          parseYuan2Currency(accountTotal?.paymentTotal),
          'alignRight',
        )}
        ${getDescItemHtml(
          intl.get('cpm_bill_print_total_refund'),
          'Total Refund',
          parseYuan2Currency(accountTotal?.refundTotal),
          'alignRight',
        )}
        </div>
      </div>
      <div class="hotel">
        <div class="left">
          ${getDescItemHtml(
            intl.get('cpm_bill_print_hotel_phone'),
            'Tel.',
            hotelBasicInfoResp?.storePhone,
          )}
          ${getDescItemHtml(
            intl.get('cpm_bill_print_hotel_address'),
            'Address',
            hotelBasicInfoResp?.storeAddress,
          )}
          ${getDescItemHtml(intl.get('cpm_bill_print_guest_sign'), 'Signature：', '')}
        </div>
        <div>
          ${getDescItemHtml(
            intl.get('cpm_bill_print_operator'),
            'Operator',
            hotelBasicInfoResp?.operater,
          )}
        </div>
      </div>
    </div>
  `;
  return container;
};
